import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p><strong>Erewash Rag</strong> - Your Premier Source for Satirical AI Slop Local News</p>
        <p>⚠️ Disclaimer: All stories are AI Generated and intended for entertainment purposes only.</p>
        <p>Any resemblance to real events or persons is purely coincidental.</p>
      </div>
    </footer>
  );
};

export default Footer; 